module.exports = __webpack_public_path__ + "static/media/tick-circle-white.cf5ac2f9.svg";